import { useState } from 'react';
import '../../owner/ownerPages.css';
import '../../owner/subscriptions/subscriptions.css';
import './packages.css';

const emptyForm = {
  name: '',
  serialNo: '',
  benefits: '',
  status: 'active',
  branch: '',
};

function PackageForm({ initialData, branchOptions = [], onSubmit, onCancel, submitLabel }) {
  const [form, setForm] = useState({
    ...emptyForm,
    branch: branchOptions[0] || '',
    ...initialData,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit?.({
      ...form,
      // Keep DB-compatible defaults for fields removed from the UI
      duration: form.duration || 'Monthly',
      price: 0,
      registrationFee: 0,
      tax: 0,
      freezeOption: false,
      autoRenewal: false,
      serialNo: form.serialNo === '' || form.serialNo == null
        ? null
        : Number(form.serialNo),
    });
  };

  return (
    <form className="subscription-form" onSubmit={handleSubmit}>
      <div className="package-form-grid">
        <div className="owner-form-group">
          <label className="owner-form-label" htmlFor="name">Package Name</label>
          <input
            id="name"
            name="name"
            className="owner-form-input"
            value={form.name}
            onChange={handleChange}
            placeholder="e.g. Premium"
            required
          />
        </div>

        <div className="owner-form-group">
          <label className="owner-form-label" htmlFor="serialNo">Serial No (start)</label>
          <input
            id="serialNo"
            name="serialNo"
            type="number"
            min="1"
            step="1"
            className="owner-form-input"
            value={form.serialNo}
            onChange={handleChange}
            placeholder="e.g. 1000"
          />
        </div>

        <p className="package-form-hint package-form-full">
          Memberships sold for this package start from this number and increase by 1.
        </p>

        <div className="owner-form-group">
          <label className="owner-form-label" htmlFor="branch">Branch</label>
          <select
            id="branch"
            name="branch"
            className="owner-form-select"
            value={form.branch}
            onChange={handleChange}
            required
          >
            <option value="">Select branch...</option>
            {branchOptions.map((branch) => (
              <option key={branch} value={branch}>{branch}</option>
            ))}
          </select>
        </div>

        <div className="owner-form-group">
          <label className="owner-form-label" htmlFor="status">Status</label>
          <select
            id="status"
            name="status"
            className="owner-form-select"
            value={form.status}
            onChange={handleChange}
          >
            <option value="active">Active</option>
            <option value="inactive">Inactive</option>
          </select>
        </div>

        <div className="owner-form-group package-form-full">
          <label className="owner-form-label" htmlFor="benefits">Benefits</label>
          <textarea
            id="benefits"
            name="benefits"
            className="owner-form-input owner-form-textarea"
            rows={4}
            value={form.benefits}
            onChange={handleChange}
            placeholder="Enter benefits (one per line)"
            required
          />
        </div>
      </div>

      <div className="subscription-form-actions">
        <button type="submit" className="owner-btn owner-btn-primary">{submitLabel}</button>
        {onCancel && (
          <button type="button" className="owner-btn owner-btn-secondary" onClick={onCancel}>
            Cancel
          </button>
        )}
      </div>
    </form>
  );
}

export default PackageForm;
